import { useIntl } from "react-intl";

const PublicLinks = () => {
    const intl = useIntl();

    const messages = {
        header: intl.formatMessage({
            id: "ConfluencePricingPage.features.publicLinks.header",
            defaultMessage: "Public links"
        }),
        content: intl.formatMessage({
            id: "ConfluencePricingPage.features.publicLinks.content",
            defaultMessage:
                "Public links allow users to share a view-only version of a Confluence page with anyone on the internet via the unique Public Link URL. Easily copy the link and share with external collaborators for easy viewing, without needing them to sign up for a Confluence account."
        }),
        altText: intl.formatMessage({
            id: "ConfluencePricingPage.features.publicLinks.altText",
            defaultMessage: "Public links screenshot."
        })
    };

    return (
        <>
            <h2>{messages.header}</h2>
            <p>{messages.content}</p>
            <img
                src="https://wac-cdn.atlassian.com/misc-assets/webp-images/public_links_1.webp"
                alt={messages.altText}
                height={350}
                loading="lazy"
            />
        </>
    );
};

export default PublicLinks;
